module.exports = __webpack_public_path__ + "img/normal-big.3bc59162.svg";